export default __webpack_public_path__ + "static/media/recent_stories_grey.c5002eb6.png";